import * as React from 'react';

import { ApButtonIcon } from '@alixpartners/ui-components';
import {
  Wrapper,
  Title,
  Helper,
  TitleWrapper,
  ActionsWrapper,
  Divider,
} from './ListItem.styles';
import { IConfigItem } from '../types';
import { SortableHandle } from 'react-sortable-hoc';

interface IProps {
  data: IConfigItem;
  onHideClick(index: number): void;
  order: number;
}

const DragHandle = SortableHandle(({ disabled }: { disabled?: boolean }) => (
  <ApButtonIcon iconName="baseline_drag_handle" disabled={disabled} />
));

export const ListItem: React.FC<IProps> = ({ data, onHideClick, order }) => {
  const { name, hidden, personnel, thirdParty } = data;

  const handleHideClick = (e: any) => {
    e.preventDefault();
    onHideClick(order);
  };

  return (
    <Wrapper hidden={hidden}>
      <TitleWrapper>
        <Title>{name}</Title>
        <Helper restricted={personnel || thirdParty}>
          Available for{' '}
          {personnel
            ? 'personnel spend data only'
            : thirdParty
            ? 'third party spend data only'
            : 'any filtering option'}
        </Helper>
      </TitleWrapper>
      <ActionsWrapper>
        <ApButtonIcon
          iconName={!hidden ? 'outline_visability' : 'outline_visability_off'}
          onClick={handleHideClick}
        />
        <Divider />
        <DragHandle disabled={hidden} />
      </ActionsWrapper>
    </Wrapper>
  );
};
